export default __webpack_public_path__ + "media/images/prezola-logo-8e5b32fd7e32e5e160d7838122ba015e.svg";